import { React, useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { getMyDirectory } from '../../features/directory/directorySlice'
import Loader from "loaders/Loader";
import MyDirectoryItem from './MyDirectoryItem'
import SettingsIcon from '@mui/icons-material/Settings'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

function UpdateDirectory() { 
    const { t } = useTranslation('settings')
    const dispatch = useDispatch()
    const { myDirectory, isDirectorySuccess, isDirectoryUpdatedSuccess, isDirectoryLoading } = useSelector((state) => state.directory)
    
    // useEffect(() => { dispatch(getMyDirectory()) }, [])

    const { profile, isSuccess } = useSelector((state) => state.profile)
 
    useEffect(() => {
        // if(profile && isSuccess){ 
            dispatch(getMyDirectory())
        // }
    }, [
        // profile, isSuccess, dispatch
    ])

    useEffect(() => {
        if(isDirectoryUpdatedSuccess){
            toast.success(t('directoryItem.updated'))
          }
    }, [isDirectoryUpdatedSuccess, t])
     
    return (
        <>
            { 
                isDirectoryLoading ?
                (
                    <LoadingState>
                        <Loader />
                    </LoadingState>
                )
                :  myDirectory ? 
                    
                     <MyDirectoryItem />
                    
                :
                (
                    <EmptyState>
                        <EmptyIcon>
                            <SettingsIcon />
                        </EmptyIcon>
                        <EmptyTitle>{t('directoryItem.notFound')}</EmptyTitle>
                        <EmptyCopy>{t('directoryItem.notFoundHelp')}</EmptyCopy>
                    </EmptyState>
                )
            }
        </>
    )
}

export default UpdateDirectory

const LoadingState = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding-top: 50px;
`

const EmptyState = styled.div`
    width: 100%;
    height: 100%;
    min-height: 320px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 24px;
    text-align: center;
    color: var(--lightThemeFontColor);
`

const EmptyIcon = styled.div`
    width: 54px;
    height: 54px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 180, 204, 0.1);
    color: var(--themeColor);
    margin-bottom: 14px;

    svg {
        font-size: 28px;
    }
`

const EmptyTitle = styled.h2`
    margin: 0;
    font-size: 18px;
    font-weight: 500;
    font-family: 'Roboto', sans-serif;
`

const EmptyCopy = styled.p`
    margin: 8px 0 0;
    max-width: 360px;
    color: var(--dFontColor);
    font-size: 13px;
    line-height: 1.45;
    font-family: 'Roboto', sans-serif;
`
